import React from 'react';
import { Blank } from 'tea-component';
// import { useIntl } from 'umi';

export default (props: any) => {
  let { text, textCN, type = 'permission' } = props;
  if (!text && !textCN) {
    textCN = '您目前无权限查看当前游戏数据，请通过顶部导航或者游戏列表申请对应权限。';
    text =
      'You do not authority to view the game data currently, please go to  NavMenu or expand the game list to get access.';
  }
  return (
    <Blank
      theme={type}
      description={
        <div>
          {textCN && <p>{textCN}</p>}
          {text && <p>{text}</p>}
        </div>
      }
      style={{ height: '74.5vh', top: 0, marginTop: 200 }}
    />
  );
};
